// 卡片上的行事曆狀態圖示（GDO-25）：只在連結後、有事件時顯示；每種狀態有說明
import type { IndexRow } from '@dayone/core/snapshot';
import { useCalendar } from '../../calendar/useCalendar.ts';
import { t } from '../../i18n/zh-TW.ts';
import { Hint } from '../../ui/Hint.tsx';
import { CalendarCheck, CalendarClock, CalendarX, ICON } from '../../ui/icons/index.ts';
import { shortDay } from './format.ts';

export function CalendarBadge({ row, currentYear }: { row: IndexRow; currentYear: number }) {
  const cal = useCalendar();
  if (cal?.auth !== 'signed_in') return null;
  const s = cal.stateOf(row);
  if (s.kind === 'none') return null;
  if (s.kind === 'synced') {
    return (
      <Hint content={t.gcal.syncedHint(shortDay(s.event.date, currentYear), s.event.origin === 'bound')}>
        <button type="button" className="badge badge-ok badge-icon gcal-badge" aria-label={t.gcal.badge.synced}>
          <CalendarCheck {...ICON} />
        </button>
      </Hint>
    );
  }
  if (s.kind === 'drift') {
    return (
      <Hint
        content={`${t.gcal.drift(shortDay(s.from, currentYear), shortDay(s.to, currentYear))}。${t.gcal.driftHint}`}
      >
        <button type="button" className="badge badge-warn badge-icon gcal-badge" aria-label={t.gcal.badge.drift}>
          <CalendarClock {...ICON} />
        </button>
      </Hint>
    );
  }
  return (
    <Hint content={t.gcal.orphanHint}>
      <button type="button" className="badge badge-warn badge-icon gcal-badge" aria-label={t.gcal.badge.orphan}>
        <CalendarX {...ICON} />
      </button>
    </Hint>
  );
}
